import React from 'react';
import { Link } from "react-router-dom";
import DocsVideo from '../reusable_components/DocsVideo';

import edit_section_open_video from '../videos/edit_section_open_video.mov';
import edit_section_fields_video from '../videos/edit_section_fields_video.mov';
import edit_section_subsections_video from '../videos/edit_section_subsections_video.mov';
import edit_section_students_video from '../videos/edit_section_students_video.mov';
import edit_section_lock_sections from '../videos/edit_section_lock_sections.mov';

export default function EditSectionDocs({ topic, setTopic, schoolType, embedded = false }) {
	const validTopics = ['edit_section_basics'];
	const editSectionTopic = embedded ? 'edit_section_basics' : (validTopics.includes(topic) ? topic : 'default');

	const chooseEditSectionTopic = (newTopic) => {
		if (editSectionTopic === newTopic) {
			setTopic(null);
		} else {
			setTopic(newTopic);
		}

		scrollToInstructions('topOfThePage');
	};

	const scrollToInstructions = (sectionId) => {
		const section = document.getElementById(sectionId);
		if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
	};

	return (
		<div className='documentation-page'>
			<div id='topOfThePage'></div>
			{!embedded &&
				<>
					<p>Use Edit Section to update section details, assignments, and placement rules.</p>
					<p className='documentation-question-heading'>What would you like help with?</p>
					<div className='choose-topic' style={{ margin: '0px 0px 10px 0px' }}>
						<Link className={`choose-topic-btn ${editSectionTopic === 'edit_section_basics' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/magnetboard/edit_section/${editSectionTopic === 'edit_section_basics' ? 'null' : 'edit_section_basics'}`} onClick={() => chooseEditSectionTopic('edit_section_basics')}>Edit section basics</Link>
					</div>
				</>
			}

			{editSectionTopic === 'edit_section_basics' &&
			<div className='documentation-container'>
				<h2 className='documentation-page-heading'>Edit Section(s)</h2>
				<div className='documentation-question-heading'>What would you like help with?</div>
				<div className='documentation-container-instruction-option-container'>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('edit_section_open')}>Open the editor from magnetboard</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('edit_section_fields')}>Update section fields and assignments</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('edit_section_subsections')}>Manage subsections and inclusion</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('edit_section_students')}>Manage students</div>
					<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions('edit_section_lock_section')}>Lock section</div>
				</div>

				<div id='edit_section_open' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Open the editor from magnetboard</div>
					<div className='documentation-step-text'>Open Edit Section by clicking the section ellipsis or double-clicking an unlocked section in Teacher/Classroom view.</div>
					<DocsVideo src={edit_section_open_video}></DocsVideo>
				</div>

				<div id='edit_section_fields' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Update section fields and assignments</div>
					<div className='documentation-step-text'>Use this screen to change a section's course, teacher(s), classroom, subsections, days/quarters, or students. You can also lock this section from this screen directly.</div>
					<div className='documentation-step-text'>When updating teachers, classrooms, or students you will see their availability listed next to their name, which can help avoid creating conflicts.</div>
					<div className='documentation-step-text'>Once you're happy with your changes, you can click Save at the top.</div>
					<DocsVideo src={edit_section_fields_video}></DocsVideo>
				</div>

				<div id='edit_section_subsections' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Manage subsections and inclusion</div>
					<div className='documentation-step-text'>Add new subsections when you want to stack/link courses together. You can add a general subsection by clicking Add Subsection or add an inclusion subsection by clicking Add Inclusion Subsection.</div>
					<div className='documentation-step-text'>You can delete a subsection or split it off into it's own individual section.</div>
					<DocsVideo src={edit_section_subsections_video}></DocsVideo>
				</div>

				<div id='edit_section_students' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Manage students</div>
					<div className='documentation-step-text'>You can add/remove students with search. Once a student is added to the section, you can lock them into the section by clicking the lock icon next their name.</div>
					<div className='documentation-step-text'>You can also do bulk student actions, like locking/unlocking all students at once, moving them to a different section, or copying them over to a different section.</div>
					<div className='documentation-step-text'>You can dive into a specific student's schedule by clicking on their name.</div>
					<DocsVideo src={edit_section_students_video}></DocsVideo>
				</div>

				<div id='edit_section_students' className='documentation-container-instruction-container'>
					<div className='documentation-container-instruction-heading'>Lock sections</div>
					<div className='documentation-step-text'>If you are happy with how a section is set up, you can lock it so it is not affected by an auto-features. It won't get auto-cleared/auto-placed on the Magnetboard and <strong>it won't allow students in or out of the section</strong>.</div>
					<DocsVideo src={edit_section_lock_sections}></DocsVideo>
				</div>
			</div>
			}
		</div>
	);
}
